import React, {useState} from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderIcon from '@mui/icons-material/Folder';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import LocalMoviesIcon from '@mui/icons-material/LocalMovies';
import TimelineIcon from '@mui/icons-material/Timeline';
import CustomListItem from "./CustomListItem";
import TheatersIcon from "@mui/icons-material/Theaters";
import {ThreeDIcon} from "../../../assets/svg-icons/ThreeDIcon";
import {useHistory} from 'react-router-dom';

const typeToIcon = {
    fileschemas: <LocalMoviesIcon fontSize="large"/>,
    folders: <FolderIcon fontSize="large"/>,
    mediafolders: <TheatersIcon fontSize="large"/>,
    procedures: <ThreeDIcon fontSize="large"/>,
    projects: <CategoryOutlinedIcon fontSize="large"/>,
};

const typeToName = {
    fileschemas: 'Media item',
    folders: 'Folder',
    mediafolders: 'Media folder',
    procedures: 'Interactive flow',
    projects: 'Project',
};

const SearchResults = ({results, searchInput, handleClose, editPromissions}) => {
    const [isSearching, setIsSearching] = useState(false);
    const history = useHistory();
    const highlightText = (text, highlight) => {
        const searchWords = highlight.split(/\s+/).map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
        const regex = new RegExp(`(${searchWords.join('|')})`, 'gi');
        const parts = text.split(regex);

        return (
            <span>
                {parts.map((part, index) => (
                    regex.test(part) ?
                        <strong key={index}>{part}</strong> :
                        <span key={index}>{part}</span>
                ))}
            </span>
        );
    };

    const getText = (result) => {
        if (typeToName[result.type] === 'Interactive flow') {
            switch (result?.ProcedureType) {
                case 3:
                    return 'Digital twin model';
                case 1:
                    return 'Media item';
                default:
                    return 'Interactive flow';
            }
        }
        return typeToName[result.type];
    }

    const getIcon = (result) => {
        if (typeToName[result.type] === 'Interactive flow') {
            switch (result?.ProcedureType) {
                case 3:
                    return <ThreeDIcon fontSize="large"/>;
                case 1:
                    return <TheatersIcon fontSize="large"/>;
                default:
                    return <TimelineIcon fontSize="large"/>;
            }
        }
        return typeToIcon[result.type] || <DescriptionIcon/>;
    }

    const buildItemRoute = (result, itemId) => {
        const folderPath = (result.NestedFolderRoute || '').split('/').slice(1).join('/');
        const base = `/project/${result.ProjectRef}/procedures`;
        return folderPath ? `${base}/${folderPath}/${itemId}` : `${base}/${itemId}`;
    };

    const open = async (result) => {
        if (result.type === 'folders') {
            history.push(buildItemRoute(result, result.FolderIdentifier));
            handleClose()
        } else if (result.type === 'procedures') {
            if (!(result?.ProcedureType === 0 || result.ProcedureType === 3 || result.ProcedureType === 1)) return;
            history.push(buildItemRoute(result, result.ProcedureIdentifier));
            handleClose()
        } else if (result.type === 'projects') {
            history.push(`/project/${result.ProjectIdentifier}/dashboard`);
            handleClose()
        }
    }

    return (
        <div className="search-global-results">
            <List className="search-global-result-list">
                {results.length > 0 ? (
                    results.map((result, index) => (
                        <div onClick={() => open(result)}>
                            <CustomListItem
                                key={index}
                                result={result}
                                searchInput={searchInput}
                                getIcon={getIcon}
                                getText={getText}
                                editPromissions={editPromissions}
                                handleClose={handleClose}
                                highlightText={highlightText}
                                isSearching={isSearching}
                                setIsSearching={setIsSearching}
                            />
                        </div>
                    ))
                ) : (
                    <ListItem>
                        <ListItemText className="search-global-result-historyText" primary="No results found." />
                    </ListItem>
                )}
            </List>
        </div>
    );
};

export default SearchResults;
